angular.module('lsnBase.deprecated.models')
  .factory('MessageModelConstants', ['LsnMessageModelConstants', function(LsnMessageModelConstants) {
    return LsnMessageModelConstants;
  }])
  .factory('MessageModel', ['LsnMessageModelV1',
    function(LsnMessageModelV1) {
      return LsnMessageModelV1;
    }
  ]);